import React from 'react';
import { CheckIcon, FileTextIcon, PawPrintIcon, ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { socialProof } from '../data/content';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/gDYbFEoGXqkuvwCs84yAHh/ChatGPT_Image_16_sept_2026,_12_57_07_a.m..png';
const features = [{
  icon: FileTextIcon,
  label: 'PDF Digital'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: PawPrintIcon,
  label: 'Cualquier raza y edad'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CheckIcon,
  label: 'Pago seguro'
}, {
  icon: CheckIcon,
  label: 'Mercado Pago'
}];
export function Hero() {
  return <header className="relative overflow-hidden bg-forest-900" data-id="element-108" data-mp="sd4aozwg34nf">
      <div aria-hidden="true" className="absolute inset-0 opacity-[0.07]" style={{
      backgroundImage: 'radial-gradient(circle at 1px 1px, #F8F4E9 1px, transparent 0)',
      backgroundSize: '28px 28px'
    }} data-id="element-109" data-mp="nbf0fmh1qv0e" />

      <div className="relative mx-auto flex max-w-3xl flex-col items-center px-5 pb-8 pt-5 text-center sm:pb-12 sm:pt-9" data-id="element-110" data-mp="3j8sg632wlnqw">
        <p className="inline-flex items-center gap-1.5 rounded-full bg-gold-400/15 px-3 py-1 text-[0.58rem] font-bold uppercase tracking-[0.14em] text-gold-300 ring-1 ring-inset ring-gold-400/30 sm:text-[0.7rem] sm:tracking-[0.18em]" data-id="element-111" data-mp="3o6kfhi5voc54">
          <StarIcon className="h-2.5 w-2.5 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-112" data-mp="3ebirwqr93i4n" />
          {socialProof.lectores} lectores · 7 Tomos + 5 Bonos
        </p>

        <h1 className="mt-3 font-display text-[2.15rem] uppercase leading-[0.95] text-cream-50 sm:mt-4 sm:text-[3.4rem] lg:text-[4rem]" style={{
        fontWeight: 900
      }} data-id="element-113" data-mp="359sy5e9wc73p">
          Pack Sin Culpa,
          <br data-id="element-114" data-mp="2vj7tb93mq6cc" />
          <span className="text-gold-400" data-id="element-115" data-mp="2vgu25bc2lea2">Sin Destrozos</span>
        </h1>

        {/* Mockup principal: entre el título y el subtítulo */}
        <div className="relative mt-3 w-full sm:mt-4" data-id="element-116" data-mp="2lla9cxssyvpj">
          <div aria-hidden="true" className="absolute left-1/2 top-1/2 h-[70%] w-[65%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-forest-600/25 blur-3xl" data-id="element-117" data-mp="2lmuz8a469qh2" />
          <img src={PRODUCT_IMAGE} alt="Pack Sin Culpa, Sin Destrozos: guía principal con 7 tomos y 5 bonos imprimibles" className="relative mx-auto w-[68%] max-w-[22rem] drop-shadow-2xl" width={1240} height={1200} sizes="(max-width: 640px) 68vw, 352px" loading="eager" decoding="async" {...{
          fetchpriority: 'high'
        }} data-id="element-118" data-mp="n98cdkmjmzmb" />
        </div>

        <p className="mt-3 max-w-xl font-display text-[0.95rem] uppercase leading-snug tracking-wide text-cream-50 sm:mt-4 sm:text-xl" style={{
        fontWeight: 600
      }} data-id="element-119" data-mp="111yb8pn67z0u">
          Método para que tu perro deje de sufrir cuando te vas
        </p>

        <p className="mt-2 max-w-lg text-[0.8rem] leading-relaxed text-cream-200 sm:text-[0.95rem]" data-id="element-120" data-mp="3hrd9kw2ghc0f">
          Protocolo de 21 días, primeros auxilios anti-destrozos y planificación paso a paso.{' '}
          <strong className="font-semibold text-cream-50" data-id="element-121" data-mp="21awemc9yyxi0">
No necesita castigos, necesita aprender a estar solo.</strong>
        </p>

        <ul className="mt-3 flex flex-wrap justify-center gap-x-3.5 gap-y-1 sm:mt-4 sm:gap-x-5" data-id="element-122" data-mp="268y69llgo553">
          {features.map(feature => <li key={feature.label} className="flex items-center gap-1.5 text-[0.7rem] font-medium text-cream-200 sm:text-sm" data-id="element-123" data-mp="2b2sm2dxy3zyw">
              <feature.icon className="h-3.5 w-3.5 text-gold-400" aria-hidden="true" data-id="element-124" data-mp="2kxkk1ivfwou7" />
              {feature.label}
            </li>)}
        </ul>

        <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-3.5 gap-y-1 text-[0.65rem] font-medium text-cream-200/75 sm:mt-5 sm:text-xs" data-id="element-125" data-mp="2tzbpqnpzcvo2">
          {trust.map(item => <li key={item.label} className="flex items-center gap-1" data-id="element-126" data-mp="zlkke0eooxyf">
              <item.icon className="h-3 w-3 text-gold-400" aria-hidden="true" data-id="element-127" data-mp="zlsvpnv5rv7i" />
              {item.label}
            </li>)}
        </ul>
      </div>
    </header>;
}